// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalV1MedicalEligibilityResultSearchDefaultResponse {
    static getAttributeTypeMap() {
        return MedicalV1MedicalEligibilityResultSearchDefaultResponse.attributeTypeMap;
    }
}
MedicalV1MedicalEligibilityResultSearchDefaultResponse.discriminator = undefined;
MedicalV1MedicalEligibilityResultSearchDefaultResponse.additionalProperties = false;
MedicalV1MedicalEligibilityResultSearchDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "MedicalV1MedicalEligibilityResultSearchDefaultResponseData"
    },
];
//# sourceMappingURL=medicalV1MedicalEligibilityResultSearchDefaultResponse.js.map